let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4m0vl")).then(() => parcelRequire('hJapP'));